import { ref, computed } from 'vue'
/**
 * This utility function takes a list/array of items and returns all elements for
 * pagination.
 *
 * @param {*} items
 *
 * @output
 * showPagination - if the numbers of items is bigger than page size,
 * pagination controller will be show on the page
 * pageItems - items show on the current page
 * currentPage - the current page show on the web page
 * pageSize - We set default page size to 20, here.
 * You can overide it by reassigning a new value in your component.
 * Or, using v-model in select tag(drop-down) to make it dyanmic.
 * pageCount - the total number of pages in pagination controler component
 */
export default function usePagination(items) {
  const pageSize = ref(20) // default to 20, see above comment
  const data = computed( () => items.value ? items.value : [])
  const { currentPage } = useFCPModel()

  watch(data, () => {
    currentPage.value = 1
  })

  const pageCount = computed(() => Math.ceil(data.value.length / pageSize.value))
  const showPagination = computed(() => data.value.length > pageSize.value)

  const pageItems = computed(() => {
    let begin = (currentPage.value - 1) * pageSize.value
    let end = begin + pageSize.value

    if (currentPage.value == pageCount.value) {
      end = data.value.length
    }

    //console.log(`Begin = ${begin} End = ${end}`)
    return data.value.slice(begin, end)
  })

  return { showPagination, pageItems, pageSize, pageCount }
}
